import type { ColumnDef } from "@tanstack/react-table";
import type { ApReceipt } from "@/accounts-payable/types";
import { receiptPaymentLabel } from "@/accounts-payable/utils";

export const paymentCol: ColumnDef<ApReceipt> = {
  id: "payment",
  header: "Paid with",
  meta: { size: "170px" },
  cell: ({ row }) => (
    <span className="text-secondary-text">
      {receiptPaymentLabel(row.original) ?? "—"}
    </span>
  ),
};
